// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-responsive {
  width: 100%;
}
@media (min-width: 991px) {
  .item-responsive {
    width: calc(33% - 10px);
    margin: 0 5px 10px;
  }
}
@media (max-width: 992px) {
  .item-responsive {
    margin-bottom: 20px;
  }
}

@media (min-width: 991px) {
  .articles-wrapper {
    padding: 20px 50px 0;
  }
}
@media (max-width: 992px) {
  .articles-wrapper {
    display: flex;
    flex-direction: column;
    padding: 16px 20px 0;
  }
}

.item-card {
  display: flex;
  flex-direction: column;
  height: 210px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}
.item-card .card-header {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
}
.item-card .card-content {
  display: flex;
  height: 100%;
}
.item-card .card-content .image-section {
  flex: 0 0 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.item-card .card-content .image-section .item-image {
  width: 160px;
  height: 160px;
  object-fit: cover;
}
.item-card .card-content .text-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  padding-left: 0;
}
.item-card .card-content .text-section .content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.item-card .card-content .text-section .content-area .item-name {
  font-size: 16px;
  font-weight: bold;
  line-height: 1.2;
}
.item-card .card-content .text-section .content-area .item-description {
  font-size: 14px;
  line-height: 1.3;
  color: #666;
}
.item-card .card-content .text-section .content-area .item-price {
  font-size: 16px;
  font-weight: bold;
  color: var(--ion-color-primary);
}
.item-card .card-content .text-section .content-area .legal-text {
  margin-top: auto;
}
.item-card .card-content .text-section .action-area {
  margin-top: auto;
}
.item-card .card-content .text-section .action-area .dotted-divider {
  margin-bottom: 12px;
}
.item-card .card-content .text-section .action-area .action-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-skeleton-items/menu-skeleton-items.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAGA;EACC,WAAA;AAFD;ACDE;EDEF;IAGE,uBAAA;IACA,kBAAA;EAAA;AACF;ACDE;EDJF;IAUE,mBAAA;EADA;AACF;;ACZE;EDgBF;IAEE,oBAAA;EADA;AACF;ACZE;EDUF;IAOE,aAAA;IACA,sBAAA;IACA,oBAAA;EADA;AACF;;AAKA;EACC,aAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;AAFD;AAIC;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;AAFF;AAKC;EACC,aAAA;EACA,YAAA;AAHF;AAKE;EACC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAHH;AAKG;EACC,YAAA;EACA,aAAA;EACA,iBAAA;AAHJ;AAOE;EACC,OAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;AALH;AAOG;EACC,OAAA;EACA,aAAA;EACA,sBAAA;AALJ;AAOI;EACC,eAAA;EACA,iBAAA;EACA,gBAAA;AALL;AAQI;EACC,eAAA;EACA,gBAAA;EACA,WAAA;AANL;AASI;EACC,eAAA;EACA,iBAAA;EACA,+BAAA;AAPL;AAUI;EACC,gBAAA;AARL;AAYG;EACC,gBAAA;AAVJ;AAYI;EACC,mBAAA;AAVL;AAaI;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;AAXL","sourcesContent":["@import '../../../theme/mixins';\n\n// Match the responsive grid layout from menu.page.scss (lines 371-398)\n.item-responsive {\n\twidth: 100%;\n\t@include desktop {\n\t\twidth: calc(33% - 10px);\n\t\tmargin: 0 5px 10px;\n\t}\n\n\t// Mobile: Make cards larger to show ~2.5 cards on screen\n\t@include mobile {\n\t\t// Increased margin between cards\n\t\tmargin-bottom: 20px;\n\t}\n}\n\n.articles-wrapper {\n\t@include desktop {\n\t\tpadding: 20px 50px 0;\n\t}\n\n\t// Mobile: Single column layout with proper spacing\n\t@include mobile {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tpadding: 16px 20px 0;\n\t}\n}\n\n// Match the item card structure from item-view.component\n.item-card {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 210px; // CRITICAL: Match exact height from PRP\n\tbackground: white;\n\tborder-radius: 8px;\n\toverflow: hidden;\n\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n\tposition: relative;\n\n\t.card-header {\n\t\tposition: absolute;\n\t\ttop: 8px;\n\t\tright: 8px;\n\t\tz-index: 2;\n\t}\n\n\t.card-content {\n\t\tdisplay: flex;\n\t\theight: 100%;\n\n\t\t.image-section {\n\t\t\tflex: 0 0 160px; // CRITICAL: Match exact width from PRP\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tpadding: 16px;\n\n\t\t\t.item-image {\n\t\t\t\twidth: 160px;\n\t\t\t\theight: 160px;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t}\n\n\t\t.text-section {\n\t\t\tflex: 1;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tpadding: 16px;\n\t\t\tpadding-left: 0;\n\n\t\t\t.content-area {\n\t\t\t\tflex: 1;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\n\t\t\t\t.item-name {\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tline-height: 1.2;\n\t\t\t\t}\n\n\t\t\t\t.item-description {\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tline-height: 1.3;\n\t\t\t\t\tcolor: #666;\n\t\t\t\t}\n\n\t\t\t\t.item-price {\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t\tcolor: var(--ion-color-primary);\n\t\t\t\t}\n\n\t\t\t\t.legal-text {\n\t\t\t\t\tmargin-top: auto;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.action-area {\n\t\t\t\tmargin-top: auto;\n\n\t\t\t\t.dotted-divider {\n\t\t\t\t\tmargin-bottom: 12px;\n\t\t\t\t}\n\n\t\t\t\t.action-buttons {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n\n// Narrow desktop range — catches the cramped layout users see at 125–150% browser\n// zoom on common screen widths, before the mobile breakpoint takes over.\n@mixin tablet {\n  @media (min-width: 991px) and (max-width: 1399px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
